const ar = {
  app_name: 'Crystal Bardawam',
  home: 'الرئيسية',
  categories: 'الفئات',
  categories_layout_6: 'عرض ٦ فئات',
  categories_layout_9: 'عرض ٩ فئات',
  medical_consultation: 'اطرح سؤالاً',
  no_image: 'لا توجد صورة',
  products: 'المنتجات',
  vip_products: 'منتجات VIP',
  vip: 'VIP',
  products_empty: 'لا توجد منتجات في هذه الفئة',
  add_to_cart: 'إضافة إلى السلة',
  added_to_cart: 'تمت الإضافة إلى السلة',
  product_unavailable: 'غير متوفر',
  discount_off: 'خصم',
  view_cart: 'عرض السلة',
  cart_title: 'السلة',
  cart_empty: 'سلتك فارغة',
  cart_empty_message: 'لا توجد منتجات في سلتك. يرجى اختيار منتج وإضافته إلى السلة.',
  cart_added_message: 'تمت إضافة المنتج إلى سلتك بنجاح.',
  cart_a11y: 'السلة',
  cart_service_title: 'نوع الطلب',
  cart_delivery_only: 'أحتاج التوصيل فقط',
  cart_delivery_install: 'أحتاج التوصيل والتركيب',
  cart_subtotal: 'المجموع الفرعي',
  cart_discount: 'الخصم',
  cart_line_total: 'الإجمالي',
  cart_delivery_fee: 'أجرة التوصيل',
  cart_delivery_free: 'توصيل مجاني',
  cart_delivery_city: 'المدينة',
  cart_offer_discount: 'خصم العرض',
  cart_grand_total: 'المجموع الكلي',
  cart_city_unknown: 'تعذر تحديد المدينة',
  cart_city_outside: 'موقعك خارج منطقة التوصيل',
  cart_zone_loading_title: 'يرجى الانتظار',
  cart_zone_loading_message: 'جاري تحديد منطقتك...',
  cart_out_of_zone_title: 'عذراً',
  cart_out_of_zone_message: 'لا يتوفر التوصيل إلى هذه المدينة. يرجى التواجد ضمن منطقة التوصيل لإرسال الطلب.',
  cart_place_order: 'إرسال الطلب',
  cart_consult_whatsapp: 'اطرح سؤالاً عبر واتساب',
  cart_order_success: 'تم إرسال الطلب',
  cart_order_success_message: 'سيتم التواصل معك قريباً',
  cart_order_failed: 'فشل إرسال الطلب',
  cart_consult_opened: 'تم فتح واتساب',
  cart_consult_opened_message: 'سؤالك جاهز للإرسال عبر واتساب',
  cart_login_required: 'يرجى التسجيل أولاً لإرسال الطلب',
  cart_city_required: 'يرجى التواجد ضمن منطقة التوصيل لإرسال الطلب',
  cart_refresh_location: 'تحديث الموقع',
  cart_view_delivery_offers: 'معلومات التوصيل والعروض',
  cart_wa_order_title: 'طلب جديد — Crystal Bardawam',
  cart_wa_consult_title: 'اطرح سؤالاً — Crystal Bardawam',
  cart_wa_name: 'الاسم',
  cart_wa_phone: 'الهاتف',
  cart_wa_city: 'المدينة',
  cart_wa_location: 'الموقع',
  cart_wa_map: 'الخريطة',
  cart_wa_items: 'المنتجات',
  cart_wa_note: 'ملاحظة',
  cart_wa_subtotal: 'المجموع',
  cart_wa_delivery: 'التوصيل',
  cart_wa_free_delivery: 'مجاني',
  cart_wa_grand_total: 'المجموع الكلي',
  product_consult_whatsapp: 'اطرح سؤالاً عبر واتساب',
  product_wa_consult_title: '💬 اطرح سؤالاً — Crystal Bardawam',
  product_wa_product: 'المنتج',
  product_wa_price: 'السعر',
  product_wa_original_price: 'السعر السابق',
  product_wa_discount: 'الخصم',
  product_description: 'الوصف',
  product_price: 'السعر',
  price_ask_message: 'راسلنا لمعرفة السعر',
  product_note: 'ملاحظة',
  order_note: 'ملاحظة الطلب',
  order_note_placeholder: 'اكتب ملاحظتك',
  special_instructions: 'تعليمات خاصة',
  special_instructions_placeholder: 'اكتب تعليماتك الخاصة',
  quantity: 'الكمية',
  increase_quantity: 'زيادة الكمية',
  decrease_quantity: 'تقليل الكمية',
  remove_from_cart: 'إزالة من السلة',
  favourite_a11y: 'المفضلة',
  search: 'بحث',
  search_placeholder: 'ابحث عن منتج...',
  search_hint: 'اكتب للبحث عن المنتجات',
  search_no_results: 'لا توجد نتائج لـ «{{query}}»',
  Settings: 'الإعدادات',
  Account: 'الحساب',
  footer_tagline: 'متجر متخصص بالزجاجيات',
  footer_quick_links: 'روابط سريعة',
  social_media: 'وسائل التواصل',
  follow_us: 'تابعنا على وسائل التواصل الاجتماعي',
  all_rights_reserved: 'جميع الحقوق محفوظة.',
  created_by: 'تم الإنشاء بواسطة',
  Welcome: 'مرحباً',
  Profile: 'الملف الشخصي',
  'orders.header': 'طلباتي',
  orders_empty: 'لا توجد طلبات',
  orders_load_failed: 'تعذر تحميل الطلبات',
  orders_total: 'المجموع',
  orders_currency: 'د.ع',
  orders_items_count: '{{count}} منتج',
  orders_status_unknown: 'غير معروف',
  orders_status_pending: 'قيد الانتظار',
  orders_status_processing: 'قيد المعالجة',
  orders_status_completed: 'مكتمل',
  orders_status_delivered: 'تم التوصيل',
  orders_status_cancelled: 'ملغى',
  orders_number: 'رقم الطلب',
  orders_date: 'التاريخ',
  orders_delivery: 'نوع التوصيل',
  orders_delivery_fee: 'أجرة التوصيل',
  orders_delivery_free: 'توصيل مجاني',
  orders_city: 'المدينة',
  orders_location: 'الموقع',
  orders_discount: 'الخصم',
  orders_delivery_delivery: 'توصيل فقط',
  orders_delivery_delivery_setup: 'توصيل وإصلاح',
  orders_delivery_delivery_only: 'توصيل فقط',
  orders_retry: 'إعادة المحاولة',
  orders_status_confirmed: 'مؤكد',
  orders_status_approved: 'موافق عليه',
  orders_status_rejected: 'مرفوض',
  orders_status_shipped: 'تم الشحن',
  orders_status_new: 'جديد',
  Favourites: 'المفضلة',
  favourites_empty: 'لا توجد مفضلات',
  favourites_load_failed: 'تعذر تحميل المفضلة',
  favourites_remove_failed: 'فشل الإزالة من المفضلة',
  favourites_save_failed: 'فشل حفظ المفضلة',
  favourites_login_required: 'يرجى تسجيل الدخول أولاً لحفظ المفضلة',
  remove_favourite: 'إزالة من المفضلة',
  Logout: 'تسجيل الخروج',
  'Delete Account': 'حذف الحساب',
  Register: 'تسجيل',
  Login: 'دخول',
  login_create_account: 'تسجيل الدخول أو إنشاء حساب',
  login_subtitle: 'لإرسال الطلبات وإنشاء الحسابات',
  login_step_phone: 'الهاتف',
  login_step_otp: 'الرمز',
  login_step_signup: 'التسجيل',
  login_phone: 'رقم الهاتف',
  login_phone_placeholder: '07XX XXX XXXX',
  login_otp: 'رمز التحقق',
  login_otp_placeholder: '000000',
  login_send_otp: 'إرسال الرمز',
  login_verify_otp: 'تأكيد الرمز',
  login_signup_submit: 'إنشاء الحساب',
  login_full_name: 'الاسم الكامل',
  login_full_name_placeholder: 'أدخل اسمك الكامل',
  login_location: 'الموقع',
  login_location_button: 'تحديد موقعي',
  login_continue: 'متابعة',
  login_error: 'خطأ',
  login_phone_invalid: 'أدخل رقم هاتف صحيحاً',
  login_send_otp_first: 'أرسل الرمز أولاً',
  login_otp_invalid: 'أدخل رمز التحقق',
  login_otp_wrong: 'الرمز غير صحيح',
  login_name_required: 'الاسم الكامل مطلوب',
  login_location_required: 'يرجى تحديد موقعك',
  login_location_denied: 'لم يتم السماح بالوصول للموقع',
  login_location_failed: 'تعذر الحصول على الموقع',
  login_otp_sent: 'تم إرسال الرمز',
  login_otp_sent_message: 'تحقق من الرسائل',
  login_otp_demo: 'رمز تجريبي:',
  login_save_failed: 'فشل الحفظ',
  login_request_failed: 'فشل الطلب. حاول مرة أخرى',
  login_token_missing: 'لم يتم استلام رمز الدخول. حاول مرة أخرى',
  signin_subtitle: 'أدخل رقم الهاتف والرمز لتسجيل الدخول',
  signin_no_account: 'لا يوجد حساب. يرجى التسجيل أولاً',
  signin_go_register: 'ليس لديك حساب؟ سجّل الآن',
  register_subtitle: 'أنشئ حساباً جديداً لإرسال الطلبات',
  register_go_signin: 'لديك حساب؟ سجّل الدخول',
  register_already_has_account: 'هذا الرقم مسجل مسبقاً. يرجى تسجيل الدخول',
  profile_save: 'حفظ',
  profile_load_failed: 'تعذر تحميل الملف الشخصي',
  profile_update_failed: 'فشل تحديث الاسم',
  profile_update_success: 'تم بنجاح',
  profile_update_success_message: 'تم تحديث اسمك',
  Setting: 'الإعدادات',
  Theme: 'المظهر',
  Language: 'اللغة',
  Fonts: 'الخطوط',
  'Help & Information': 'المساعدة والمعلومات',
  delivery_info_title: 'معلومات التوصيل والعروض',
  delivery_info_intro: 'عزيزي المستخدم، معلومات حول التوصيل والعروض',
  delivery_info_cities_section: 'أسعار التوصيل حسب المدينة',
  delivery_info_offers_section: 'أنواع العروض',
  delivery_info_farewell: 'دمتم بصحة وعافية دائماً',
  delivery_info_empty: 'لا تتوفر معلومات حالياً',
  delivery_info_load_failed: 'تعذر تحميل المعلومات',
  delivery_offer_type_free: 'توصيل مجاني',
  delivery_offer_type_discount: 'خصم',
  delivery_page: 'التوصيل',
  offers_page: 'العروض',
  'share App': 'مشاركة التطبيق',
  'Rate Us': 'قيّمنا',
  select_language: 'اختر اللغة',
  close: 'إغلاق',
  'Select Font': 'اختر الخط',
  'Select Theme': 'اختر المظهر',
  'Light Mode': 'الوضع الفاتح',
  'Dark Mode': 'الوضع الداكن',
  'Black Mode': 'الوضع الأسود',
  'font one': 'الخط الأول',
  'font two': 'الخط الثاني',
  'font three': 'الخط الثالث',
  'System default': 'خط النظام',
  confirm_logout_message: 'هل تريد تسجيل الخروج؟',
  confirm_delete_message: 'هل تريد حذف حسابك؟',
  logout: 'خروج',
  already_logged_in: 'أنت مسجل الدخول بالفعل باسم {{name}}',
  go_to_profile: 'الذهاب إلى الملف الشخصي',
  delete: 'حذف',
  cancel: 'إلغاء',
  logout_failed: 'فشل تسجيل الخروج',
  version_label: 'الإصدار {{version}}',
  go_back: 'رجوع',
  account_a11y: 'الحساب',
  search_a11y: 'بحث',
  onboarding_skip: 'تخطي',
  onboarding_next: 'التالي',
  onboarding_back: 'رجوع',
  onboarding_tap_to_continue: 'اضغط للمتابعة',
  onboarding_get_started: 'ابدأ',
  onboarding_step_lang: 'اللغة',
  onboarding_step_theme: 'المظهر',
  onboarding_step_font: 'الخط',
  onboarding_splash_tagline: 'إلكترونيات من متجر فومسي',
  onboarding_lang_title: 'اختر اللغة',
  onboarding_lang_subtitle: 'حدد لغتك المفضلة للتطبيق',
  onboarding_theme_title: 'اختر المظهر',
  onboarding_theme_subtitle: 'فاتح أو داكن أو أسود — يمكنك تغييره لاحقاً',
  onboarding_font_title: 'اختر الخط',
  onboarding_font_subtitle: 'اختر خطاً مريحاً للقراءة',
  onboarding_font_sample: 'نموذج نص',
  network_offline_title: 'لا يوجد اتصال بالإنترنت',
  network_offline_message: 'يرجى التحقق من Wi-Fi أو بيانات الهاتف ثم المحاولة مرة أخرى',
  network_retry: 'إعادة المحاولة',
  notifications_title: 'الإشعارات',
  notifications_subtitle: 'اضبط الإشعارات والصوت التلقائي',
  notifications_enable: 'تفعيل الإشعارات',
  notifications_enable_desc: 'استقبل إشعارات عند وجود طلبات أو رسائل',
  notifications_sound: 'صوت الإشعار',
  notifications_sound_desc: 'تشغيل الصوت تلقائياً عند وصول إشعار',
  notifications_permission_status: 'حالة الإذن',
  notifications_status_granted: 'مفعّل',
  notifications_status_denied: 'مرفوض',
  notifications_status_undetermined: 'غير محدد',
  notifications_success: 'تم بنجاح',
  notifications_enabled_message: 'تم تفعيل الإشعارات',
  notifications_error: 'خطأ',
  notifications_permission_denied: 'لم يتم منح إذن الإشعارات',
  notifications_enable_failed: 'فشل تفعيل الإشعارات',
  notifications_sound_failed: 'فشل تغيير إعداد الصوت',
  notifications_android_settings_hint: 'اسمح بالإشعارات من إعدادات الجهاز',
  'version.updateAvailableTitle': 'يتوفر تحديث',
  'version.updateAvailableMessage':
    'يتوفر إصدار جديد من التطبيق. يرجى التحديث للمتابعة.',
  'version.update': 'تحديث',
  download_app_title: 'حمّل التطبيق',
  download_app_subtitle: 'حمّل تطبيق Crystal Bardawam على هاتفك واطلب بسهولة.',
  download_ios: 'تحميل لـ iOS',
  download_android: 'تحميل لأندرويد',
  download_app_hint: 'التطبيق متوفر لنظامي أندرويد و iOS.',
  download_app_page: 'تحميل التطبيق',
  download_app_badge: 'متوفر للهاتف',
  download_get_it_on: 'حمّل من',
  download_why_title: 'لماذا تطبيقنا؟',
  download_why_subtitle: 'مميزات تطبيق Crystal Bardawam',
  download_feat_fast_title: 'سرعة عالية',
  download_feat_fast_desc: 'التطبيق سريع الاستجابة والأداء',
  download_feat_delivery_title: 'توصيل سريع',
  download_feat_delivery_desc: 'نوصل المنتجات بسرعة إلى منزلك',
  download_feat_secure_title: 'حماية البيانات',
  download_feat_secure_desc: 'بياناتك محمية بالكامل',
  download_feat_easy_title: 'سهل الاستخدام',
  download_feat_easy_desc: 'تصميم بسيط وسلس للجميع',
  download_cta_title: 'حمّله الآن!',
  download_banner_desc: 'متوفر لأندرويد و iOS',
  home_download_title: 'حمّل تطبيق بردوام',
  home_download_subtitle: 'للهدايا والجوائز والخصومات والتوصيل المجاني',
  home_download_cta: 'تحميل التطبيق',
  home_download_gift: 'هدايا',
  home_download_reward: 'جوائز',
  home_download_discount: 'خصومات',
  home_download_free_delivery: 'توصيل مجاني',
};

export default ar;
